<template>
  <div
    class="popup"
    @click.self="popupClose"
    @touchmove.self="handleTouchMove"
    @touchstart.self="handleTouchStart"
  >
    <div
      class="popup__wrapper" :class="[
        { '--swipe': swipeClose && mainStore.isMobile },
      ]"
    >
      <button v-if="!withoutClose" class="popup__close" @click="popupClose">
        <SvgIcon icon="close" />
      </button>
      <div class="popup__content">
        <div v-if="icon" class="popup__container">
          <SvgIcon :icon="icon" class="popup__icon" />
        </div>
        <span v-if="title" class="popup__title">{{ title }}</span>
        <slot name="header" />
        <slot name="body" />
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" src="./AppPopup.ts"></script>

<style lang="scss" src="./AppPopup.scss"></style>
